import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
  // Checkbox,
  // TextField,
  useTheme,
  // Stack,
} from "@mui/material";
import AcceptQuatationSubmit from "@/app/features/tender/components/view/quatation-accept-sbmit";
import { useSelector } from "react-redux";
import { RootState } from "@/store/type";
// import OrderQuatationSubmit from "@/app/features/tender/components/view/order-quatation-submit";
// import regionsData from "@/app/features/company/data/regions_lite.json";
// import citiesData from "@/app/features/company/data/cities_lite.json";
import { IoClose } from "react-icons/io5";
import TableComponent from "@/app/global-components/table";
import RefuseQuatationSubmit from "@/app/features/tender/components/view/quatation-refuse-sbmit";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG, ROLE } from "@/types";
import { cn } from "@/lib/utils";
import { isNull } from "lodash";
// import useRegisterCompany from "@/hooks/use-register-company";
// import useOrder from "@/hooks/use-order";
import useOffer from "@/hooks/useTender";

// const primaryColor = "#644980";
interface QuotationDetailsModalProps {
  open: boolean;
  onClose: () => void;
  quotation: any | null;
  offerStatus?: string;
}
// interface Product {
//   productId: string;
//   unitName: string;
//   SKUCode: string;
//   quantity: number;
//   unitPrice: number;
//   vat: number;
//   notice: string;
//   attachment?: File | null;
//   image?: { url: string } | null | undefined;
// }

// interface City {
//   city_id: number;
//   region_id: number;
//   name_ar: string;
// }
// interface Region {
//   region_id: number;
//   name_ar: string;
// }
// interface Option {
//   value: string;
//   label: string;
// }
// interface CompanySchema {
//   id: string;
//   nameAr: string;
//   nameEn: string;
//   website?: string; // Optional field
//   contactInfo?: string; // Optional field
//   city?: string; // Optional field
//   region?: string; // Optional field
//   orderNr: number;
// }
const QuotationDetailsModal: React.FC<QuotationDetailsModalProps> = ({
  open,
  onClose,
  quotation,
  offerStatus,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  if (!quotation) return null;
  console.log(quotation);
  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const userRole = authUser?.role;
  // const myCompany = useSelector((state: RootState) => state.auth.myCompany);
  // const { getCompany } = useRegisterCompany();
  // const [company, setCompany] = useState<CompanySchema | null>(null);
  // const { createOrder, isOrderLoading } = useOrder();
  const { acceptQuatation, refuseQuatation, isLoading, error } = useOffer();

  const totalPrice = quotation.products.reduce(
    (acc: any, product: any) =>
      acc +
      (product.unitPrice ?? 0) *
        (product.quantity ?? 0) *
        (1 + (product.vat ?? 0) / 100),
    0
  );
  const totalVat = quotation.products.reduce(
    (acc: any, product: any) =>
      acc +
      (product.unitPrice ?? 0) *
        (product.quantity ?? 0) *
        ((product.vat ?? 0) / 100),
    0
  );
  const getDateLabel = (days: string) => {
    switch (days) {
      case "7":
        return `7 ${t("time.days")}`;
      case "14":
        return `14 ${t("time.days")}`;
      case "30":
        return `30 ${t("time.days")}`;
      default:
        return `7 ${t("time.days")}`;
    }
  };
  // const [selectedItems, setSelectedItems] = useState<string[]>([]);
  // const [Edquotation, setEdquotation] = useState<any>(quotation);
  // const [regions, setRegions] = useState<Option[]>([]);
  // const [cities, setCities] = useState<Option[]>([]);
  const handleAction = async (action: Function, id: string | undefined) => {
    if (quotation && id) {
      try {
        await action(id);
        onClose();
      } catch (err) {
        console.error("Error performing action:", err);
      }
    }
  };

  // const handleCheckboxChange = (productId: string) => {
  //   setSelectedItems((prevSelected) =>
  //     prevSelected.includes(productId)
  //       ? prevSelected.filter((id) => id !== productId)
  //       : [...prevSelected, productId]
  //   );
  // };
  const { breakpoints } = useTheme();

  // const handleCreateOrder = async () => {
  //   if (Object.keys(selectedItems).length === 0) {
  //     alert(t("alerts.error.noItemsSelected"));
  //     return;
  //   }
  //   const selectedProducts = Edquotation.products
  //     .filter((product: Product) => selectedItems.includes(product.productId))
  //     .map((product: any) => ({
  //       itemId: product.productId,
  //       item: product.unitName,
  //       SKUCode: product.SKUCode || "",
  //       quantity: product.quantity,
  //       price: product.unitPrice,
  //       vat: product.vat || "15",
  //       discount: 0, // Example discount
  //       notice: "", // Example notice
  //       image: product.image,
  //       attachment: product.attachment,
  //     }));
  //   const orderData = {
  //     title: "Order for Tender", // Example title
  //     endDate: new Date().toISOString(), // Example end date
  //     deliverDate: new Date(
  //       new Date().getTime() + 7 * 24 * 60 * 60 * 1000
  //     ).toISOString(), // Deliver in 7 days
  //     type: "Tiny",
  //     status: "Planning",
  //     region: myCompany.region,
  //     city: myCompany.city,
  //     address: myCompany.address,
  //     fileName: Edquotation.fileName,
  //     fileDescription: Edquotation.fileDescription,
  //     fileId: Edquotation.fileId,
  //     attachmentName: Edquotation.attachmentName,
  //     attachmentDescription: Edquotation.attachmentDescription,
  //     attachmentId: Edquotation.attachmentId,
  //     attachmentRequired: false,
  //     attachmentDeliverDays: Edquotation.attachmentDeliverDays,
  //     contactInfo: Edquotation.contactInfo,
  //     tenderId: Edquotation.tenderId,
  //     companyId: Edquotation.companyId,
  //     userId: authUser?.id,
  //     products: selectedProducts,
  //     Sendedproducts: [],
  //     OrderNr: company ? company.orderNr + 1 : 1,
  //     DeliveryMethod: Edquotation.DeliveryMethod,
  //     paymentMethod: Edquotation.paymentMethod,
  //   };
  //   try {
  //     await createOrder(orderData);
  //     await acceptQuatation(Edquotation.id);
  //     alert(t("alerts.success.orderCreated"));
  //     onClose();
  //   } catch (err) {
  //     console.error("Error creating order:", err);
  //   } /**/
  // };
  // const handleQuantityChange = (productId: string, value: number) => {
  //   const updatedProducts = Edquotation.products.map(
  //     (product: Product) =>
  //       product.productId === productId
  //         ? { ...product, quantity: value } // Update the quantity for the matching product
  //         : product // Leave other products unchanged
  //   );
  //   setEdquotation({
  //     ...quotation,
  //     products: updatedProducts,
  //   });
  // };
  // useEffect(() => {
  //   setRegions(
  //     regionsData.map((region: Region) => ({
  //       value: region.region_id.toString(), // Convert to string
  //       label: region.name_ar,
  //     }))
  //   );
  // }, []);
  // useEffect(() => {
  //   setCities(
  //     citiesData.map((City: City) => ({
  //       value: City.city_id.toString(),
  //       label: City.name_ar,
  //     }))
  //   );
  // }, []);
  // const getCity = (value: string) => {
  //   let city = cities.find((item) => parseInt(item.value) === parseInt(value));
  //   if (city) {
  //     return city.label;
  //   } else {
  //     return "";
  //   }
  // };
  // const getRegion = (value: string) => {
  //   let city = regions.find((item) => parseInt(item.value) === parseInt(value));
  //   if (city) {
  //     return city.label;
  //   } else {
  //     return "";
  //   }
  // };
  // useEffect(() => {
  //   getCompany(Edquotation.companyId).then((Company) => {
  //     setCompany(Company.data);
  //   });
  // }, []);

  // const handlePrint = () => {
  //   generatePDFOpportunity({
  //     quotation: {
  //       ...quotation,
  //       tender: {
  //         ...quotation.tender,
  //         city: getCity(quotation.tender.city),
  //         region: getRegion(quotation.tender.region),
  //       },
  //     },
  //     totalPrice,
  //   });
  // };

  const columns = [
    {
      title: t("item.fields.image"),
      field: "image",
      render: (row: any) =>
        row.image ? (
          <img
            src={row.image}
            alt="item"
            className="border mx-auto rounded-xl"
            style={{ width: 70, height: 70 }}
          />
        ) : (
          "—"
        ),
    },
    {
      title: t("checkout.fields.name"),
      field: "unitName",
    },
    {
      title: "SKU",
      field: "SKUCode",
    },
    {
      title: t("checkout.fields.quantity"),
      field: "quantity",
      render: (row: any) => row.quantity,
    },
    {
      title: t("checkout.fields.unitPrice"),
      field: "unitPrice",
    },
    {
      title: t("orders.fields.notes"),
      field: "notice",
    },
  ];
  // console.log(quotation.company);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          [breakpoints.down("md")]: {
            width: "100vw",
            maxHeight: "100vh",
          },
        },
      }}
    >
      <IoClose
        onClick={onClose}
        className={cn(
          "absolute cursor-pointer text-4xl top-3",
          locale === LANG.AR ? "left-3" : "right-3"
        )}
      />

      <DialogTitle
        className="!p-0"
        sx={{
          textAlign: locale === LANG.AR ? "right" : "left",
          fontWeight: "bold",
          color: "#333",
        }}
      >
        <div className="text-3xl p-4 border-b">{t("quotations.details")}</div>
      </DialogTitle>
      <DialogContent className="!overflow-scroll no-scrollbar">
        {/* <Stack flexDirection={"row"} alignItems={"center"} gap={2}>
          <Typography
            variant="h6"
            sx={{ color: primaryColor, fontWeight: "bold" }}
            align={locale === LANG.AR ? "right" : "left"}
          >
            {t("company.fields.name")}:
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: "bold", color: "#333" }}
            align={locale === LANG.AR ? "right" : "left"}
          >
            {quotation.company?.CompanyNr}
          </Typography>
        </Stack> */}

        <Typography
          variant="h5"
          sx={{ mb: 2, mt: 4, color: "#333" }}
          align={locale === LANG.AR ? "right" : "left"}
        >
          {t("products.list")}
        </Typography>
        <TableComponent
          columns={columns}
          data={quotation.products}
          rowKeyField="productId"
          maxHeight={220}
          pagination={false}
        />

        <Grid container spacing={3} sx={{ mb: 2 }}>
          <Grid item xs={12} md={6}>
            <Typography>
              {t("delivery.suggestedTime")} ({t("time.days")}):{" "}
              {isNull(quotation.deliverDays) ? "" : quotation.deliverDays}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography>
              {t("offers.validityPeriod1")}:{" "}
              {isNull(quotation.DeadLineDate)
                ? ""
                : getDateLabel(quotation.DeadLineDate)}
            </Typography>
          </Grid>
        </Grid>
        {userRole === ROLE.BUYER ? (
          ""
        ) : (
          <Typography mb={2}>
            {t("payment.method1")}{" "}
            {isNull(quotation.paymentMethod)
              ? ""
              : quotation.paymentMethod === "1"
              ? t("payment.direct")
              : t("payment.deferred1")}
          </Typography>
        )}

        <Typography mb={2}>
          {t("delivery.title")}:{" "}
          {isNull(quotation.DeliveryMethod)
            ? ""
            : quotation.DeliveryMethod === "FedEx"
            ? "FedEx"
            : quotation.DeliveryMethod === "DHL Express"
            ? "DHL Express"
            : quotation.DeliveryMethod === "DHL Express"
            ? "SPL"
            : quotation.DeliveryMethod}
        </Typography>
        <Box sx={{ textAlign: locale === LANG.AR ? "right" : "left", mt: 3 }}>
          <Typography
            variant="body1"
            sx={{
              color: "#333",
              textAlign: locale === LANG.EN ? "right" : "left",
            }}
          >
            {t("item.fields.vat")}:{" "}
            <strong>
              {totalVat.toFixed(2)} {t("checkout.summary.currency")}
            </strong>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#333",
              textAlign: locale === LANG.EN ? "right" : "left",
            }}
          >
            {t("orders.fields.totalPrice")}:{" "}
            <strong>
              {totalPrice.toFixed(2)} {t("checkout.summary.currency")}
            </strong>
          </Typography>
        </Box>
        {error && (
          <Typography variant="body2" color="error" align="right">
            {error}
          </Typography>
        )}
      </DialogContent>

      <DialogActions className="flex gap-4">
        {/* Action Buttons */}
        {/* {(offerStatus === "Closed" || offerStatus === "Accepted") &&
          userRole === ROLE.BUYER && (
            <OrderQuatationSubmit
              isLoading={isOrderLoading}
              onClick={() => handleCreateOrder()}
            />
          )} */}
        {offerStatus === "Closed" && userRole === ROLE.BUYER && (
          <AcceptQuatationSubmit
            isLoading={isLoading}
            onClick={() => handleAction(acceptQuatation, quotation.id)}
          />
        )}
        {userRole === ROLE.BUYER && (
          <RefuseQuatationSubmit
            isLoading={isLoading}
            onClick={() => handleAction(refuseQuatation, quotation.id)}
          />
        )}
        {/*{offerStatus === "Accepted" && quotation.status === "Accepted" && (
          <CreateOrderQuatationSubmit isLoading={isLoading} onClick={() => handleAction(PaymentRequestQuatation, quotation.id)} />
        )}
        
        {userRole === "Buyer" && offerStatus === "PaymentConfirmation" && quotation.status === "PaymentConfirmation" && (
          <SendRequestQuatationSubmit isLoading={isLoading} onClick={() => handleAction(SendRequestQuatation, quotation.id)} />
        )}
        {userRole === "Seller" && offerStatus === "PaymentConfirmation" && quotation.status === "Sending" && (
          <SendQuatationSubmit isLoading={isLoading} onClick={() => handleAction(SendQuatation, quotation.id)} />
        )}
        {userRole === "Buyer" && offerStatus === "Sending" && quotation.status === "Sending" && (
          <ReceiveQuatationSubmit isLoading={isLoading} onClick={() => handleAction(ReceiveQuatation, quotation.id)} />
        )}
          */}
        <Button onClick={onClose} className="!text-gray-200 !px-3 !bg-zinc-600">
          {t("actions.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuotationDetailsModal;
